export default __webpack_public_path__ + "static/media/back-arrow.8294d491.svg";